<template>
    <div>
        <fade-down-modal :show="show">
            <div class="delMsgbox comMsgbox">
                <div class="header">
                    <header-tag :title="title"></header-tag>
                </div>
                <div class="content">
                    <div><img src="@/assets/img/icon/u1488.png" alt="" /></div>
                    <div>是否删除账号“</div>
                    <div class="val" v-text="val"></div>
                    ”？
                </div>
                <div><img src="@/assets/img/icon/u207.png" alt="" /></div>
                <div class="btn">
                    <div class="right">
                        <a href="#" class="blue-btn" @click.prevent="_confirm()"
                            >确认</a
                        >
                        <a
                            href="#"
                            class="default-btn"
                            @click.prevent="_cancel()"
                            >取消</a
                        >
                    </div>
                </div>
            </div>
        </fade-down-modal>
        <sms
            :show="showSmsMsgbox"
            @getDxCode="getsmscode"
            :smsError="messageError"
        ></sms>
    </div>
</template>

<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";
import { mapState, mapActions } from "vuex";
import FadeDownModal from "_c/modals/fadeDown";
import { _del } from "@/requests/emplyee";
import sms from "./sms";
import httpApi from "@/apis/httpApi";
export default {
    name: "emplyeeModals",
    components: {
        HeaderTag,
        FadeDownModal,
        sms
    },
    props: {
        currentPage: Number
    },
    data() {
        return {
            title: "删除",
            showSmsMsgbox: false,
            messageError: ""
        };
    },
    computed: {
        ...mapState({
            show: state => state.emplyee.show,
            val: state => state.emplyee.val
        })
    },
    watch: {
        currentPage() {
            this.$emit("del", this.currentPage);
        }
    },
    mounted() {},
    methods: {
        ...mapActions([
            "emplyee/actionSetShow",
            "emplyee/actionSetVal",
            "emplyee/actionSetActive"
        ]),
        getsmscode(data) {
            this._confirm(data);
        },
        /* eslint-disable */
        async _confirm(data) {
            //单条删除表格数据
            let obj = {
                passportName: this.val,
                smsCode: ""
            };
            let res = await _del(obj);
            if (res.code == 200) {
                this.messageError = "";
                this.showSmsMsgbox = false;
                this._cancel();
                this["emplyee/actionSetActive"](1);
                this.$emit("del", this.currentPage);
            } else if (res.code == 401) {
                let data = {
                    url: httpApi.emplyee.del,
                    data: obj
                };
                let res = await window.$sms.show(data);
                if (res) {
                    this["emplyee/actionSetActive"](1);
                    this["emplyee/actionSetShow"](false);
                }
                // window.$sms.show(data,() => {
                //     console.log('验证成功')
                // })
            } else {
                this.messageError = res.msg;
            }
        },
        _cancel() {
            this["emplyee/actionSetShow"](false);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
.delMsgbox {
    width: 600px;
    height: 200px;
    .content {
        height: 70px;
        line-height: 70px;
        overflow: hidden;
        text-align: left;
        padding-left: 50px;
        div {
            float: left;
        }
        .val {
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        img {
            position: relative;
            top: 2px;
            margin-right: 5px;
        }
    }
}
</style>
